<div class="custom-page-column pdf-page app-cp-10-75-12-20" id="cp751220">
  <p class="font-small text-end">
    <b
      >COMMERCIAL PROPERTY<br />
      CP 10 75 12 20</b
    >
  </p>
  <p class="font-medium" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY.</b>
  </p>
  <p class="font-large" style="text-align: center">
    <b>CYBER INCIDENT EXCLUSION</b>
  </p>

  <p class="font-small">
    This endorsement modifies insurance provided under the following:
  </p>
  <p class="font-small ps-10">
    COMMERCIAL PROPERTY COVERAGE PART<br />
    STANDARD PROPERTY POLICY
  </p>

  <table class="font-small">
    <tbody>
      <tr>
        <td style="width: 50%; vertical-align: top;">
          <ol type="A">
            <li style="font-weight: bold;">
              <span style="font-weight: normal;">
              The following exclusion is added to Paragraph <b>B.</b><br />
              <b>Exclusions:</b><br />
              We will not pay for loss or damage caused directly or indirectly
              by the following. Such loss or damage is excluded regardless of
              any other cause or event that contributes concurrently or in any
              sequence to the loss.<br />
              <b>Cyber Incident</b>
              <ol>
                <li style="font-weight: bold; padding-bottom: 10px; padding-top: 5px;">
                  <span style="font-weight: normal;">
                  Unauthorized access to or use of any computer system
                  (including electronic data).
                  </span>
                </li>
                <li style="font-weight: bold; padding-bottom: 10px;">
                  <span style="font-weight: normal;">
                  Malicious code, virus or any other harmful code that is
                  directed at, enacted upon or introduced into any computer
                  system (including electronic data) and is designed to access,
                  alter, corrupt, damage, delete, destroy, disrupt, encrypt,
                  exploit, use or prevent or restrict access to or the use of
                  any part of any computer system (including electronic data) or
                  otherwise disrupt its normal functioning or operation.
                  </span>
                </li>
                <li style="font-weight: bold; padding-bottom: 10px;">
                  <span style="font-weight: normal;">
                  Denial of service attack which disrupts, prevents or restricts
                  access to or use of any computer system, or otherwise disrupts
                  its normal functioning or operation.
                  </span>
                </li>
              </ol>
            </span>
            </li>
          </ol>
        </td>
        <td style="width: 50%; vertical-align: top;">
          <ol type="A" start="2">
            <li style="font-weight: bold;">
              <span style="font-weight: normal;">
              <b>Exceptions And Limitations</b>
              <ol>
                <li style="padding-bottom: 10px; padding-top: 5px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  <b>Fire Or Explosion</b><br>
                  If a cyber incident as described in Paragraphs
                  <b>A.1.</b> through <b>A.3.</b> of this exclusion results in
                  fire or explosion, we will pay for the loss or damage caused
                  by that fire or explosion.
                </span>
                </li>
                <li style="padding-bottom: 10px; font-weight: bold;">
                  <span style="font-weight: normal;">
                  <b>Additional Coverage</b><br />
                  The exclusion in Paragraph <b>A.</b> does not apply to the
                  extent that coverage is provided in the:<br />
                  <ol type="a">
                    <li style="font-weight: bold;">
                      <span style="font-weight: normal;">
                      Additional Coverage – Electronic Data; or
                      </span>
                    </li>
                    <li style="font-weight: bold;">
                      <span style="font-weight: normal;">
                      Additional Coverage – Interruption Of Computer Operations.
                      </span>
                    </li>
                  </ol>
                  </span>
                </li>
                <li style="padding-bottom: 10px;">
                  <b>Electronic Commerce Endorsement</b><br />
                  The exclusion in Paragraph <b>A.</b> does not apply to the
                  Electronic Commerce (E-Commerce) endorsement when attached to
                  your policy.
                </li>
              </ol>
              </span>
            </li>
            <li>
              <b>Vandalism</b><br />
              The following is added to Vandalism, if Vandalism coverage is not
              otherwise excluded under the Standard Property Policy or the
              Causes Of Loss – Basic, Broad or Special Forms and if applicable
              to the premises described in the Declarations:<br />
              Vandalism does not include a cyber incident as described in
              Paragraph <b>A.</b>
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
</div>
